import { CenterReportCriteriaDataRequest, useSaveCenterReportCriteriaData } from '@/module/ResearchCenter';

import { Id, useAppNotification } from '@feature/utils';

export function useSaveCriteriaData(labId: Id, criteriaCode: string, onSuccess: () => void) {
  const notification = useAppNotification();
  const { mutate, isPending } = useSaveCenterReportCriteriaData(labId, criteriaCode);
  const onSubmit = (request: CenterReportCriteriaDataRequest) => {
    mutate(request, {
      onSuccess: () => {
        notification.success();
        onSuccess();
      },
      onError: notification.error,
    });
  };

  return {
    onSubmit,
    isPending,
  };
}
